<template>
  <div class="plv-ia-qn-sidebar">
    <div class="plv-ia-qn-sidebar__top">
      <button
        class="plv-ia-btn-new plv-ia-btn-blue pws-vclass-btn-blue"
        :class="{'pws-vclass-btn-blue-disabled': isEditing}"
        :disabled="isEditing"
        @click="handleCreateClick"
      >
        {{ t('plvIA.answerCard.create') }}
      </button>
      <button
        class="plv-ia-btn-new pws-vclass-btn-new"
        :class="{'pws-vclass-btn-new-disabled': isEditing}"
        :disabled="isEditing"
        @click="handleUploadClick"
      >
        {{ t('plvIA.answerCard.import') }}
      </button>
    </div>
    <div class="plv-ia-qn-sidebar__middle">
      <ul ref="nav-list" class="plv-ia-qn-sidebar-list">
        <li v-show="isNew" class="plv-ia-qn-nav-item plv-ia-qn-nav-item--active">{{ t('plvIA.questionnaire.newQuestionnaire') }}</li>
        <li
          v-for="(item, index) in list"
          :key="item.questionnaireId"
          :class="['plv-ia-qn-nav-item', {
            'plv-ia-qn-nav-item--active': !isNew && curIndex === index
          }]"
          @click="handleQnChange(index)"
        >
          {{ item.name }}
          <span :class="getLabelCls(item.status)">{{ getLabel(item.status) }}</span>
        </li>
      </ul>
    </div>
    <div class="plv-ia-qn-sidebar__bottom">
      <span class="plv-ia-btn-new pws-vclass-btn-new" @click="handleDownload">{{ t('plvIA.answerCard.downloadTemplate') }}</span>
    </div>

    <div v-show="false" @change="handleUploadChange">
      <input
        ref="pickFile"
        type="file"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      />
    </div>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';
import { STATUS } from '@/assets/app/questionnaire/helper';

export default {
  name: 'QuestionnaireSidebar',
  mixins: [Locale],
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    isEditing: Boolean,
    isNew: Boolean,
    curIndex: {
      type: Number,
      default: -1,
    },
    sendRoomList: {
      type: Array,
      default() {
        return [];
      }
    }
  },

  methods: {
    getLabel(status) {
      return {
        [STATUS.SENDED]: this.t('plvIA.questionnaire.sent'),
        [STATUS.FINISHED]: this.t('plvIA.questionnaire.terminated'),
        [STATUS.NOT_SENDED]: '',
      }[status];
    },

    getLabelCls(status) {
      const defaultClassName = 'plv-ia-qn-nav-item__label';
      return {
        [STATUS.SENDED]: `${defaultClassName} ${defaultClassName}--ongoing pws-qn-nav-item__label--ongoing`,
        [STATUS.FINISHED]: `${defaultClassName} ${defaultClassName}--finished pws-qn-nav-item__label--finished`,
        [STATUS.NOT_SENDED]: defaultClassName,
      }[status] || defaultClassName;
    },

    handleCreateClick() {
      this.$emit('create');
    },

    handleUploadClick() {
      const input = this.$refs.pickFile;
      input.value = '';
      input.click();
    },

    handleUploadChange() {
      const input = this.$refs.pickFile;
      const file = input.files[0];
      this.$emit('upload', file);
    },

    handleQnChange(index) {
      this.$emit('qn-change', index);
    },

    handleDownload(index) {
      this.$emit('download', index);
    },
  }
};
</script>

<style lang="scss">
.plv-ia-qn-sidebar {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.plv-ia-qn-sidebar-list {
  height: 100%;
}

.plv-ia-qn-sidebar__top {
  width: 100%;
  box-sizing: border-box;
  padding: 16px 28px;
  display: flex;
  justify-content: space-between;

  .plv-ia-btn-new {
    width: 64px;
    position: relative;
  }
}

.plv-ia-qn-sidebar__middle {
  box-sizing: border-box;
  flex: 1;
  overflow-y: scroll;
}

.plv-ia-qn-sidebar__bottom {
  width: 100%;
  box-sizing: border-box;
  padding: 24px 0;
  line-height: 20px;
  text-align: center;

  a {
    text-decoration: none;
  }
}

.plv-ia-qn-nav-item {
  box-sizing: border-box;
  text-overflow: ellipsis;
  word-break: keep-all;
  white-space: nowrap;
  line-height: 48px;
  padding: 0 1em;
  width: 100%;
  overflow: hidden;
  color: #263238;
  font-size: 12px;
  position: relative;
  cursor: pointer;
  user-select: none;

  &--active {
    background-color: #fff;
    color: #2196F3;
  }
}

.plv-ia-qn-nav-item__label {
  $width: 50px;
  $height: 20px;
  $scale: 0.8; // 固定按0.8倍缩小元素

  position: absolute;
  width: $width;
  line-height: $height;
  left: -5px;
  // left: -($width - $width * $scale) / 2;
  top: -2px;
  // top: -($height - $height * $scale) / 2;
  transform: scale($scale);

  color: #fff;
  border-radius: 0 0 10px 0;
  font-size: 12px;
  padding: 0 3px;
  text-align: center;
}

.plv-ia-qn-nav-item__label--ongoing {
  background-color: #ff5631;
}

.plv-ia-qn-nav-item__label--finished {
  background-color: #2196F3;
}
</style>
